import QRCode from 'qrcode-js-package';

(function () {
	"use strict";

	angular.module("angular.emlpayments")
        .directive("emlQrCode", qrCode);

	qrCode.$inject = [];

	function qrCode() {
		return function (scope, element, attrs) {

			new QRCode(element.get(0), {
				text: attrs.emlQrCode,
				width: attrs.height || 300,
				height: attrs.width || 300,
				colorDark: "#000000",
				colorLight: "#ffffff",
				correctLevel: QRCode.CorrectLevel.H
			});

		};
	}

}());